/*eslint-disable */
var $ = window.jQuery = require('jquery')
import {
  mapGetters,
  } from 'vuex';
export default {
  name: 'vista-public-media-details',
  components: {
  },
  props: [],
  data() {
    return {
      popularVideosData:null,
      popularVideosResults:[],
      mediaVideoId:'',
      selectedVideoInfoByID:[]
    }
  },
  computed: {
    ...mapGetters([
      'getListVistaPublicOfVideoGetters'
    ]),
    getVistaPublicMediaListFun(){
      return this.$store.getters.getListVistaPublicOfVideoGetters.data;
    },
  },
  mounted () {
  },
  created(){
    this.mediaVideoId = this.$route.params.videoID
    this.getSelectedVideoInfoMethod(this.mediaVideoId)
  },
  methods: {
    getSelectedVideoInfoMethod(ID){
      this.$store.dispatch('getListVistaPublicOfVideoFun').then((res) => {
        this.selectedVideoInfoByID = res.data.data.items.filter(media => media.snippet.resourceId.videoId === ID);
        return this.selectedVideoInfoByID;
      }).catch((err) => {

      })
    }
  },
  watch:{
    getVistaPublicMediaListFun(newData, oldData){
      this.popularVideosData = newData
      this.popularVideosResults = this.popularVideosData.items 
    },
    '$route.params.videoID'(newId, oldId) {
      this.mediaVideoId = newId
      this.getSelectedVideoInfoMethod(newId)
    }
  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('dashboard')
    next();
  },
}